module.exports = __webpack_public_path__ + "static/media/calstatela.89b140d0.png";